import React, { useEffect, useRef } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';

import { TooltipIconButton } from '@paragon/client-tools';

import { searchChanged } from '../store/slices/projectFiltersSlice';
import { useAppDispatch, useAppSelector } from './hooks';

export function ProjectsSearchField() {
  const dispatch = useAppDispatch();
  const search = useAppSelector((state) => state.projectFilters.search);
  const hasSearch = search !== '';

  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      const input = searchInputRef.current;
      if ((event.ctrlKey || event.metaKey) && event.code === 'KeyF' && input) {
        event.preventDefault();
        input.focus();
        input.select();
      }
    }

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  function clearSearch() {
    dispatch(searchChanged(''));
  }

  return (
    <TextField
      size="small"
      autoComplete="off"
      inputRef={searchInputRef}
      placeholder="Search name, customer, contact…"
      value={search}
      onChange={(event) => dispatch(searchChanged(event.target.value))}
      onKeyDown={(event) => {
        if (event.code === 'Escape' && hasSearch) {
          event.stopPropagation();
          clearSearch();
        }
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: hasSearch && (
            <InputAdornment position="end">
              <TooltipIconButton title="Clear search" size="small" onClick={clearSearch}>
                <ClearIcon />
              </TooltipIconButton>
            </InputAdornment>
          ),
        },
      }}
      sx={{ flex: 1, minWidth: 200 }}
    />
  );
}
